import { HashMap } from 'shared/types/commonView';
import { InspectionTemplateModel } from 'shared/domain/template/inspectionTemplateModel';

export function toTemplateModelsObject(
  result: HashMap<InspectionTemplateModel>,
  curr: InspectionTemplateModel
): HashMap<InspectionTemplateModel> {
  result[curr._id] = curr;
  return result;
}
